import { Profile } from "./Profile";
import { FooterPortafolio } from "./FooterPortafolio";
import { BannerPortafolio } from "./BannerPortafolio";
import { ButtonDarkMode } from "./ButtonDarkMode";
import { useState } from "react";

export function Portafolio({ profile, posts, projects, skills }) {
    const [darkMode, setDarkMode] = useState(true);

    const changeDarkMode = () => {
        setDarkMode(!darkMode);
    }

    return (
        <section className={`portfolio ${darkMode ? 'portfolio--dark' : ''}`}>
            <ButtonDarkMode
                changeDarkMode={changeDarkMode}
                isDarkMode={darkMode} />
            <div className="portfolio__banner container">
                <BannerPortafolio />
            </div>
            <div className="portfolio__body container">
                <Profile
                    profile={profile}
                    posts={posts}
                    projects={projects}
                    skills={skills} />
            </div>
            <footer className="portfolio__footer container">
                <FooterPortafolio
                    profile={profile} />
            </footer>
        </section>
    );
}